import { useCallback } from "react";

import { apiSlice, useDeleteLayerMutation, useLazyGetLayersQuery } from "fond/api";
import { useAppDispatch } from "fond/utils/hooks";

/**
 * Return a function that deletes the version's layers with the given layer keys.
 */
export const useDeleteLayersByKey = (versionId: string): ((layerKeys: string[]) => Promise<void>) => {
  const dispatch = useAppDispatch();
  const [getLayers] = useLazyGetLayersQuery();
  const [deleteLayer] = useDeleteLayerMutation();

  return useCallback(
    async (layerKeys: string[]) => {
      const layers = await getLayers(versionId).unwrap();
      const ids = Object.values(layers.entities)
        .filter((layer) => layerKeys.includes(layer.LayerKey))
        .map((layer) => layer.ID);
      if (ids.length === 0) return;

      await Promise.all(ids.map((id) => deleteLayer(id).unwrap()));
      dispatch(
        apiSlice.util.invalidateTags([
          { type: "Layers", id: versionId },
          { type: "FeatureTotals", id: versionId },
        ])
      );
    },
    [dispatch, getLayers, deleteLayer, versionId]
  );
};
